import React from 'react';
import { Box } from '@wix/design-system';
import type { LayoutComponentProps } from '../../app-box.types';

export function WideAppBox({
  appName = null,
  appIcon = null,
  appTeaser = null,
  companyName = null,
  topBadge = null,
  ctaButton = null,
  reviewsInfo = null,
  bottomBadge = null,
  className,
}: LayoutComponentProps) {
  return (
    <Box
      className={className}
      width="100%"
      height="100%"
      gap="12px"
      dataHook="wide-app-box"
    >
      {appIcon}
      <Box width="100%" align="space-between">
        <Box direction="vertical">
          <Box gap="12px">
            {appName}
            {topBadge}
          </Box>
          {companyName ? <Box marginBottom="6px">{companyName}</Box> : null}
          {appTeaser}
        </Box>
        <Box verticalAlign="middle">
          <Box marginRight="12px">{bottomBadge}</Box>
          {reviewsInfo}
          {ctaButton ? <Box marginLeft="24px">{ctaButton}</Box> : null}
        </Box>
      </Box>
    </Box>
  );
}
